import UserMob from "../store/UserMob";
import {useContext} from "react";
import {UserContext} from "../context/UserProvider";


export const useUser = (): UserMob => useContext(UserContext)